import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=bb18b866&scoped=true&"
import script from "./TagEdit.vue?vue&type=script&lang=js&"
export * from "./TagEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=bb18b866&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18b866",
  null
  
)

export default component.exports